import Const from 'constants';

const defaultStateData = {
    playersQuantity: 1,
    ignoredPositions: new Set(),
    subValue: 100,
    isEnabled: false,
};

const defaultState = {
    data: cp(defaultStateData),
    all() {
        return {...this.data};
    },
    isEnabled() {
        return Boolean(this.data.isEnabled);
    },
    getPlayersQuantity() {
        return Number(this.data.playersQuantity);
    },
    isPositionIgnored(position) {
        return this.data.ignoredPositions.has(position);
    },
    getIgnoredPositions() {
        return [...this.data.ignoredPositions];
    },
    getSubValue() {
        return this.data.subValue;
    },
};

export default function (state = defaultState, action) {
    state = {...state};

    if (action.type === Const.PROJECTED_OWNERSHIP_FORCE_SET_DATA_FROM_STORAGE) {
        const data = action.data;
        data.ignoredPositions = new Set(data.ignoredPositions);

        state = {
            ...defaultState,
            data,
        };
    } else if (action.type === Const.PROJECTED_OWNERSHIP_FORCE_SET_IS_ENABLED) {
        state.data.isEnabled = Boolean(action.isEnabled);
    } else if (action.type === Const.PROJECTED_OWNERSHIP_FORCE_SET_RANGE) {
        state.data.playersQuantity = action.quantity;
    } else if (action.type === Const.PROJECTED_OWNERSHIP_FORCE_SET_IGNORED_POSITION) {
        const {position, isIgnored} = action;
        if (isIgnored) {
            state.data.ignoredPositions.add(position);
        } else {
            state.data.ignoredPositions.delete(position);
        }
    } else if (action.type === Const.PROJECTED_OWNERSHIP_FORCE_SET_SUB_PERCENT) {
        state.data.subValue = action.value;
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        const data = cp(defaultStateData);
        data.ignoredPositions = new Set();

        state = {
            ...defaultState,
            data,
        };
    }

    return state;
}
